// Api Yarn Focus : 3004
import axios from "axios";
import { setupInterceptors } from "../modules/auth/services/tokenManager";
import { WAREHOUSE_API_URL } from "../constants/config";
export const warehouseApiClient = axios.create({
  baseURL: WAREHOUSE_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
setupInterceptors(warehouseApiClient, WAREHOUSE_API_URL);
